// eslint-disable-next-line import/prefer-default-export
export const EMPTY_VALUES = ['', null, undefined];
